// 透過 @ay-nestjs/share 產生
/* eslint-disable */
import { ProfileDto } from '../gosu-api/dto/profile.dto';
import { wsc } from '../wsc';
import { UploadResponse } from '@ay-nestjs/share-client';
import { Observable } from 'rxjs';

export class ParticipantModel {
  static refresh(token: string): Promise<string> {
    return wsc.execute('/ws/participant/refresh', token) as any;
  }

  static uploadAvatar(file: File): Observable<UploadResponse<{ url: string }>> {
    return wsc.upload('/ws/participant/uploadAvatar', file) as any;
  }

  static fetchParticipantById(id: number): Promise<ProfileDto> {
    return wsc.execute('/ws/participant/fetchParticipantById', id) as any;
  }
}
// 4551540d0e76811e5ce4cd9e54efa06aed3d7e9b5bd8ded2cb610b42795c3905
